// Refreshes content at specified interval
jQuery(function () {
  var selector = '[data-behaviour~="auto-refresh"]';

  function setupAutoRefresh(element) {
    var interval = jQuery(element).data("refresh-interval");
    var url = jQuery(element).data("refresh-url");
    setInterval(function () {
      jQuery.ajax(url);
    }, interval);
  }

  jQuery(selector).each(function () {
    setupAutoRefresh(this);
  });
});
